module.exports = __webpack_public_path__ + "static/media/index.519cec67.mjs";